import instance from 'api';
import { IApplicationAccident, IApplicationAccidentDefectType, IApplicationAccidentParams } from './interfaces';

export const saveApplicationAccident = (applicationAccident: IApplicationAccident) => {
  return instance()
    .post<IApplicationAccident>('/applicationAccident/save', applicationAccident)
    .then((response) => response.data);
};

export const saveApplicationAccidentV2 = (data: {
  realEstateGuids: string[];
  defectTypeId?: number;
  comment?: string;
  photoList?: string[];
}) => {
  return instance()
    .post('/applicationAccident/v2/save', data)
    .then((response) => response.data);
};

export const getApplicationAccidentList = (realEstateGuid: string, params: IApplicationAccidentParams) => {
  return instance()
    .get<{ list: IApplicationAccident[]; totalCount: number }>(`/applicationAccident/list`, {
      params: {
        ...params,
        realEstateGuid,
      },
    })
    .then((response) => response.data);
};

export const getApplicationAccidentDefectsByPositionShort = () => {
  return instance()
    .get<IApplicationAccidentDefectType[]>('/applicationAccident/defectsByPositionShort')
    .then((response) => response.data);
};

export const checkApplicationAccidents = (realEstateGuid: string) => {
  return instance()
    .get<{ hasAccident: boolean }>(`/applicationAccident/hasAccident`, { params: { realEstateGuid } })
    .then((response) => response.data);
};
